/* eslint-disable no-param-reassign */
import { put, call, takeLatest, select } from 'redux-saga/effects';
import FileSaver from 'file-saver';
import _ from 'lodash';

import { getFilterParams, showMessage } from 'utils/helpers';
import { request, pagableRequest } from 'api';
import { TYPE, ACTION } from './actions';
import * as selectors from './selectors';

function* fetchCollectionsTransactionsHandler({ payload = {} }) {
    try {
        const filters = yield select(selectors.filters);

        yield put(ACTION.fetchCollectionsTransactionsLoading());

        const res = yield call(pagableRequest(payload), {
            url: '/transactions/cash-collection',
            params: getFilterParams(filters, (params) => {
                if (params.masterIds) {
                    params.userIds = params.masterIds;
                    delete params.masterIds;
                }
            })
        });

        yield put(ACTION.fetchCollectionsTransactionsSuccess(res.data));
    } catch (err) {
        yield put(ACTION.fetchCollectionsTransactionsError(err));
        console.error(err);
    }
}

function* exportToExcel() {
    try {
        const filters = yield select(selectors.filters);
        showMessage({ type: 'warning', message: 'Почалося завантаження звіту - це може зайняти деякий час.' });

        const res = yield call(request, {
            responseType: 'arraybuffer',
            url: '/transactions/cash-collection/export',
            params: getFilterParams(filters),
        });

        const contentDisposition = _.get(res, 'headers.content-disposition', 'filename=report.xls');
        const [, filename] = contentDisposition.match(/filename=(.*)/);

        const blob = new Blob([res.data], { type: 'text/plain;charset=utf-8' });
        FileSaver.saveAs(blob, filename);
    } catch (err) {
        console.log(err);
    }
}

export default [
    takeLatest(TYPE.FETCH_COLLECTIONS_TRANSACTIONS, fetchCollectionsTransactionsHandler),
    takeLatest(TYPE.EXPORT_TO_EXCEL, exportToExcel),
];
